module.exports = __webpack_public_path__ + "static/paper-fb97584d84436e47811e9ec16831261a.svg";